/**
 * The reducer
 * @param {object} state - the state passed in by useReducer
 * @param {object} updatedValues - the new values
 */
export const apiParamsReducer = (state, updatedValues) => ({
    ...state,
    ...updatedValues
});
export const pageSizeOptionGenerator = (count) => {
    let options;
    if (count === 0) {
        options = [{ value: -1, text: 'All' }];
    } else if (count > 0 && count < 15) {
        options = [{ value: -1, text: 'All' }];
    } else if (count >= 15 && count <= 30) {
        options = [
            { value: 15, text: '15' },
            { value: -1, text: 'All' }
        ];
    } else if (count >= 31 && count <= 49) {
        options = [
            { value: 15, text: '15' },
            { value: 30, text: '30' },
            { value: -1, text: 'All' }
        ];
    } else if (count >= 50) {
        options = [
            { value: 15, text: '15' },
            { value: 30, text: '30' },
            { value: 50, text: '50' }
        ];
    } else {
        throw new Error('Total item count should not be negative value');
    }

    return options;
};
export const defaultPageInfo = {
    count: 0,
    hasNextPage: false,
    hasPrevPage: false,
    isFirstPage: true,
    isLastPage: true,
    pageCount: 1,
    pageNumber: 1,
    pageSize: -1,
    totalItemCount: 0,
    pageSizeOptions: [{ value: -1, text: 'All' }]
};
export const mapPageInfo = (obj) => {
    const mapped = {
        count: obj.count,
        totalItemCount: obj.totalItemCount === 0 ? obj.count : obj.totalItemCount,
        pageCount: obj.pageCount,
        pageNumber: obj.pageNumber,
        pageSize: obj.pageSize === 999 ? -1 : obj.pageSize,
        hasPreviousPage: obj.hasPreviousPage,
        hasNextPage: obj.hasNextPage,
        isFirstPage: obj.isFirstPage,
        isLastPage: obj.isLastPage,
        pageSizeOptions: pageSizeOptionGenerator(obj.totalItemCount)
    };

    const notMatchPageSize = () => !mapped.pageSizeOptions.find((o) => o.value === mapped.pageSize);

    // The page size after each search may become irrelevant. If initial loading of page size 15 with total item 27
    // is followed by selecting differenct deal type, it triggers a new search. If the new result contains only 6 itmes
    // then the page size option should be only one - All. This post-search-check prevent the page size option from being blown.
    if (mapped.count > 0 && notMatchPageSize()) {
        mapped.pageSize = mapped.pageSizeOptions[0].value; // reset page option
    }

    return mapped;
};
